import { Text } from "@chakra-ui/react";
import { Button, ButtonProps } from "src/components/base/button";
import { IconDownloadAppStore, IconDownloadPlayStore } from "src/components/icons";
import { IButtonCtaProps } from "src/types/cta";

export const ButtonCta = ({
    url,
    name,
    target,
    variant,
    colorScheme,
    w = ["100%", "auto"],
    ...props
}: IButtonCtaProps & Omit<ButtonProps, "type" | "colorScheme" | "variant" | "name">) => {
    if (variant === "image") {
        return (
            <Button _hover={{ background: "transparent" }} as="a" href={url} target={target} variant="ghost" borderRadius={0} p={0} w={w} {...props}>
                {colorScheme === "app-store" ? <IconDownloadAppStore /> : <IconDownloadPlayStore />}
            </Button>
        );
    }

    return (
        <Button as="a" href={url} target={target} colorScheme={colorScheme ?? "green"} variant={variant ?? "solid"} w={w} {...props}>
            <Text pointerEvents="none" as="span" paddingY="1px" overflow="hidden" textOverflow="ellipsis">
                {name ?? undefined}
            </Text>
        </Button>
    );
};
